export const Variables = {
  bg: "#100F11",
  "sub-bg": "#18171ABF",

  color: "#FFFFFF",
  orange: "#FF5C00",
  
  font: "Kanit",
};
